module.exports = __webpack_public_path__ + "img/86.19817d66.jpg";